import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storeApi } from "../../api/axios";

/**
 * Fetch store details by ID
 */
export const getStoreById = createAsyncThunk(
  "store/getStoreById",
  async ({ storeId }, { rejectWithValue }) => {
    try {
      const res = await storeApi.get(`/v1/stores/details?store_id=${storeId}`);
      return res.data || {};
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Slice
const storeSlice = createSlice({
  name: "store",
  initialState: {
    details: {},
    loading: false,
    error: null,
  },
  reducers: {
    hydrateStoreDetails: (state, action) => {
      state.details = action.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      // GET STORE
      .addCase(getStoreById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStoreById.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(getStoreById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { hydrateStoreDetails } = storeSlice.actions;
export default storeSlice.reducer;
